module.exports = ".vertical-offset-100 {\n  padding-top: 150px; }\n\n.capslockalert {\n  color: red; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/adminlogin/adminlogin.component.scss
// module id = ./src/app/adminlogin/adminlogin.component.scss
// module chunks = main